export const tr = {
    add: 'Seç',
    cancel: 'İptal',
    title: 'Kreatif «{creativeName}»'
};
